import { DataCard } from '@fluentsms/agentnet-web-components';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { FC } from 'react';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import { ConfigurationListItem, ConfigurationUnderwriterList } from './ConfigurationUnderwriterList';
import { UNDERWRITER_PRODUCT_TEST_IDS } from './feature-details-tabs';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dataCard: {
      height: 'fit-content',
    },
    manageUnderwritersButton: {
      textTransform: 'none',
      fontWeight: 600,
      padding: 0,
      minWidth: 0,
      '&:not(.Mui-disabled)': {
        color: theme.palette.primary.main,
        opacity: 1,
      },
      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
        opacity: 1,
      },
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.dark,
      },
    },
    content: {
      padding: theme.spacing(3),
    },
  }),
);

export interface FeatureDetailsConfigurationCardProps {
  isEnabled: boolean;
  items: ConfigurationListItem[];
  onManageUnderwritersClick?: () => void;
}

export const FeatureDetailsConfigurationCard: FC<FeatureDetailsConfigurationCardProps> = ({
  isEnabled,
  items,
  onManageUnderwritersClick,
}) => {
  const classes = useStyles();

  return (
    <DataCard
      heading="Available Underwriters"
      className={classes.dataCard}
      actions={
        <AgentNetButton
          variant="text"
          color="primary"
          className={classes.manageUnderwritersButton}
          disabled={!isEnabled}
          onClick={onManageUnderwritersClick}
          data-testid={UNDERWRITER_PRODUCT_TEST_IDS.manageUnderwriterLink}
        >
          Manage Underwriters
        </AgentNetButton>
      }
    >
      <Box className={classes.content}>
        <ConfigurationUnderwriterList items={items} />
      </Box>
    </DataCard>
  );
};
